<template>
  <div
    v-if="data"
    :class="[$style.advancedList, {[$style.fullScreen]: isShowModal}, {[$style.opacity]: isScreen}]"
    :style="listStyles"
  >
    <button v-if="!isShowModal" :class="$style.btnAccordion" @click="isOpened = !isOpened">
      <div>{{ data.logName || data.name }}</div>
      <span :class="{[$style.caretClosed]: !isOpened}">
        <img src="@/assets/images/icons/computer/screenshots/additional-angle.svg">
      </span>
    </button>
    <div v-if="isOpened" :class="$style.container">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'isShowModal', 'isScreen'],
  data: () => ({
    isOpened: true,
  }),
  computed: {
    listStyles() {
      return {
        height: this.isOpened ? '400px' : '43px',
        overflow: this.isOpened ? 'auto' : 'hidden',
        borderColor: this.data ? this.data.color : '#2985bf',
        boxShadow: this.data ? `0 0 5px ${this.data.color}` : '',
      };
    },
  },
};
</script>

<style lang="scss" module>
  .advancedList {
    display: flex;
    flex-direction: column;
    border: 2px solid transparent;
    resize: vertical;
    background: $white;
    min-height: 43px;
  }
  .fullScreen {
    resize: none;
    height: calc(100vh - 350px) !important;
    margin: 20px;
  }
  .opacity {
    opacity: 0.6;
    transition: all 0.3s;
    border: none;
    width: 500px;
  }
  .opacity:hover {
    opacity: 1;
  }
  .btnAccordion {
    cursor: pointer;
    user-select: none;
    border: 2px solid transparent;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 20px;
    background: $white;
    font-size: 16px;
    font-weight: 500;
    height: 43px;
  }
  .caretClosed {
    transform: rotate(180deg);
  }
  .container {
    display: flex;
    flex-direction: column;
    gap: 27px;
    padding: 11px 24px;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
  }
</style>
